import { getCatalogIsTimed } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getCatalogRegistration } from '@/redux/modules/catalog/registration/catalogRegistration.selectors';
import { getCountDown } from '@/redux/modules/bidCountDown';
import { useAppSelector } from '@/redux/hooks';
import React, { useEffect, useRef } from 'react';

type Props = {
    catalogId: number;
    itemId: number;
    onCountdownEnd: () => void;
};

export const useGetShowCountdown = ({ catalogId, itemId, onCountdownEnd }: Props) => {
    const [count, setCount] = React.useState<number>(21);
    const countRef = React.useRef<number>(count);
    countRef.current = count;
    const timer = useRef<ReturnType<typeof setInterval>>(null);
    const { approved } = useAppSelector((state) => getCatalogRegistration(state, catalogId));
    const isTimed = useAppSelector((state) => getCatalogIsTimed(state, catalogId));
    const timeStamp = useAppSelector((state) => getCountDown(state, itemId));

    const shouldShowTimer = Boolean(timeStamp) && isTimed && count < 5 && approved;

    useEffect(() => {
        if (!timer.current && Boolean(timeStamp)) {
            timer.current = setInterval(() => {
                if (countRef.current > 0) {
                    setCount(countRef.current - 1);
                    countRef.current = countRef.current - 1;
                } else if (countRef.current === 0) {
                    onCountdownEnd();
                }
            }, 1000);
        } else if (!Boolean(timeStamp)) {
            clearInterval(timer.current);
            timer.current = null;
        }
        return () => {
            clearInterval(timer.current);
            timer.current = null;
        };
    }, [onCountdownEnd, timeStamp]);

    useEffect(() => {
        setCount(timeStamp < 0 ? 4 : 21);
    }, [timeStamp]);

    return shouldShowTimer;
};
